<script setup lang="ts">
import type { FilePreviewData } from '#layers/assets/types/file';
import { useFileInfo } from '#layers/assets/composables/use-file-info';

const props = defineProps<{
	file: FilePreviewData | null;
}>();

const { isImage, title } = useFileInfo(() => props.file);
</script>

<template>
	<DDisplayValueEmpty v-if="!file" />
	<DTooltip v-else :text="title">
		<div class="aspect-square h-full self-stretch overflow-clip">
			<RenderAssetImage v-if="isImage && file" class="size-full rounded-sm object-cover" :file>
				<template #error>
					<FileTypeIcon :file />
				</template>
			</RenderAssetImage>
			<FileTypeIcon v-else-if="file" :file />
		</div>
	</DTooltip>
</template>
